export const IconFindMore = ({
  className = null,
  width = '1em',
  height = '1em',
  fill = '#fff',
  stroke = '#E10A0A',
  strokeWidth = '1.5',
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 6 8"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.4.8L4.6 4 1.4 7.2"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
